export const SHOW_NOTIFICATION = 'zola/notifications/SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'zola/notifications/HIDE_NOTIFICATION';
export const CLEAR_NOTIFICATIONS = 'zola/notifications/CLEAR_NOTIFICATIONS';



// WEBPACK FOOTER //
// ./src/actions/types/NotificationActionTypes.js